import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import Grid from './Grid';
import Next from '../../pagination/Next';
import Prev from '../../pagination/Prev';
import Card from '../../common/Card';
import CardLoading from '../../common/CardLoading';

function GridNav({
  dataHook, id, perPage, width, height,
  rowCount, rowWidth, rowHeight, columnCount,
  style
}) {

  rowWidth = rowWidth ?? Config.CARD_WIDTH;
  rowHeight = rowHeight ?? Config.CARD_HEIGHT + Config.GRID_PAD;
  columnCount = columnCount ?? Math.floor(width / rowWidth);
  if (!rowCount) {
    rowCount = (dataHook && dataHook.items !== null) ? ((dataHook.next) ? Math.floor((dataHook.items.length + perPage) / columnCount) : Math.round(dataHook.items.length / columnCount) ) : 0;
    if (rowCount === 0) { rowCount = 1 }
  }

  const itemData = dataHook ? ((dataHook.id === id && dataHook.items !== null) ? dataHook.items : null) : null;
  const bestCardWith = Math.floor(width / columnCount); //OLD - /*Config.CARD_WIDTH*/

  return (
    <div style={{ ...style }}>
      { (dataHook) ? (
        <>
          { dataHook.pagination.start !== 0 ? (
            <Prev active={(dataHook.pagination.start !== 0)} onClick={dataHook.pagination.prevStack} style={{ position: `absolute`, left: 8, top: 45 }} />
          ) : null }
          <Next active={dataHook.pagination.end <= dataHook.pagination.total && !dataHook.loading} onClick={dataHook.pagination.nextStack} style={{ position: `absolute`, right: 8, top: 45 }} />
        </>
      ) : null}
      <Grid
        columnCount={columnCount}
        columnWidth={bestCardWith}
        rowCount={rowCount}
        rowHeight={rowHeight}
        itemData={itemData}
        height={height}
        width={width}
        loadMore={null}
        style={{}}
        gutter={{ top: 4, left: 4, width: 4 }}
        element={ <Card /> }
        loadingElement={ <CardLoading /> }
      />
    </div>
  )
}

GridNav.propTypes = {
  dataHook: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  perPage: PropTypes.number,
  forceHeight: PropTypes.number,
  rowMax: PropTypes.number,
  columnMax: PropTypes.number,
  style: PropTypes.object
}

export default GridNav;
